import gql from 'graphql-tag';

const GET_FOOTER_CONTENT = gql`
  query getFooterContent {
    getFooterContent {
      title
      footer_links_column {
        link_list {
          link_title
          links {
            link_text
            url
          }
        }
      }
      social_column {
        social_profiles {
          social_network {
            icon {
              icon
              svg
            }
            social_network_link {
              title
              href
            }
          }
        }
        social_stores {
          social_stores_items {
            image {
              src {
                url
              }
              alt
            }
            link {
              href
            }
          }
        }
        text {
          text_link {
            title
            href
          }
        }
        chat_cta_text
        feedback_cta_text
        hide_chat_cta
        hide_feedback_cta
      }
      footer_links {
        link {
          title
          href
        }
      }
    }
  }
`;

export default GET_FOOTER_CONTENT;
